import { TextStyle } from '@superops/ui-design-system';
import React from 'react';
import { FormattedMessage } from 'react-intl';

function AssetAgeCell(props) {
  const { data: orgData, cell, column = {} } = props;
  const { field } = column;
  const allData = cell?.row?.original;
  const data = allData && allData[field.name];
  const cellValue = data || orgData;

  if (Number(cellValue) === 0) {
    return (
      <span>
        <FormattedMessage id="common.less.than.a.year" />
      </span>
    );
  }
  if (Number(cellValue) > 0) {
    return (
      <span>
        <FormattedMessage
          id="common.assetAge.years"
          values={{ assetAgeName: cellValue }}
        />
      </span>
    );
  }
  return (
    <TextStyle variation="subdued">
      <FormattedMessage id="app.noData.message" />
    </TextStyle>
  );
}

export default AssetAgeCell;
